import { Wallet } from "lucide-react";

const n0 = (v) => (v == null ? "—" : Math.round(v).toLocaleString("es-PY"));
const PCT = (v) => (v == null ? "" : `${Math.round(v)}%`);

/* Capacidad de pago, requerimiento de financiamiento y proyección (bloques 4 y 5 de la planilla ListadoClientesBalanceTM) */
export function CapacidadPagoCard({ p, anios }) {
  const filas = p?.capacidad_pago_archivo || [];
  if (!filas.length) return null;
  const proyKey = Object.keys(filas.find((f) => Object.keys(f).some((k) => k.startsWith("proyeccion_"))) || {}).find((k) => k.startsWith("proyeccion_"));
  const cols = [...(anios || []).map(String).filter((a) => filas.some((f) => f[a])), ...(proyKey ? [proyKey] : [])];
  const tot = filas.find((f) => /total generaci/i.test(f.concepto));
  const sup = filas.find((f) => /superavit|déficit|deficit/i.test(f.concepto));
  const ult = cols[cols.length - 1];
  const tono = (v) => (v == null ? "text-slate-500" : v >= 0 ? "text-emerald-700" : "text-red-700");
  return (
    <section className="rounded-xl border border-emerald-900/15 bg-white p-4" data-testid="ac-capacidad-pago">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500"><Wallet className="h-4 w-4 text-[#0f5233]" />Capacidad de pago y requerimiento de financiamiento · planilla del sistema</div>
      <dl className="mt-2 grid grid-cols-2 gap-2 text-xs sm:grid-cols-4">
        {[["Generación de caja", tot, 2], ["Superávit / déficit", sup, 2]].flatMap(([k, f, i]) => cols.slice(-2).map((c) => (
          <div key={k + c} className="rounded-md bg-slate-50 px-2.5 py-1.5"><dt className="text-slate-500">{k} {c.replace("proyeccion_", "proy. ")}</dt><dd className={`font-semibold ${tono(f?.[c]?.[i])}`} data-testid={`ac-cap-${k === "Generación de caja" ? "caja" : "superavit"}-${c}`}>US$ {n0(f?.[c]?.[i])}</dd></div>
        )))}
      </dl>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-[11px]" data-testid="ac-capacidad-pago-tabla">
          <thead><tr className="text-left text-slate-500"><th className="py-1 pr-2">Concepto</th>{cols.map((c) => <th key={c} className="pr-2 text-right">{c.replace("proyeccion_", "Proy. ")}<div className="font-normal">saldo · % · caja</div></th>)}</tr></thead>
          <tbody>
            {filas.map((f, i) => {
              const total = /total|superavit|déficit|deficit|generaci.n de caja a cierre/i.test(f.concepto);
              return (
                <tr key={i} className={`border-t border-slate-100 ${total ? "bg-emerald-50/60 font-semibold" : ""}`}>
                  <td className="py-1 pr-2">{f.concepto}</td>
                  {cols.map((c) => { const v = f[c] || []; return <td key={c} className={`pr-2 text-right tabular-nums ${total ? tono(v[2]) : ""}`}>{v[0] != null && !total ? `${n0(v[0])} · ${PCT(v[1])} · ` : ""}{n0(v[2])}</td>; })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {ult && sup?.[ult]?.[2] != null && <p className="mt-2 text-xs text-slate-700" data-testid="ac-capacidad-pago-lectura">{sup[ult][2] >= 0 ? `Con la realización sensibilizada de cobranzas y stock, el cliente cubre sus vencimientos y le queda un superávit de US$ ${n0(sup[ult][2])} en ${ult.replace("proyeccion_", "la proyección ")}.` : `Aun renovando préstamos y proveedores, le falta US$ ${n0(-sup[ult][2])} para cubrir vencimientos en ${ult.replace("proyeccion_", "la proyección ")}: riesgo de pedir refinanciación.`}</p>}
    </section>
  );
}
